import { render } from "./V-Calendar.vue?vue&type=template&id=37c9a5a2"
import script from "./V-Calendar.vue?vue&type=script&lang=js"
export * from "./V-Calendar.vue?vue&type=script&lang=js"
script.render = render

export default script